module.exports = __webpack_public_path__ + "static/media/home.15cde9a4.jpg";